import styles from './style.postcss';

import React, { PureComponent } from 'react';
import { Icon, testClass as baseTestClass } from 'omni-common-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import invariant from 'invariant';

const RENDER_ALL_BUTTONS_LIMIT = 4;

export const testClass = (klass) => baseTestClass(`page-selector-${klass}`);

class PageSelector extends PureComponent {
  constructor(props) {
    super(props);
    this._onPreviousClicked = this._onPreviousClicked.bind(this);
    this._onNextClicked = this._onNextClicked.bind(this);
    this._onButtonClicked = this._onButtonClicked.bind(this);
  }

  componentWillMount() {
    this._validateLast(this.props.last);
  }

  componentWillUpdate(nextProps) {
    this._validateLast(nextProps.last);
  }

  _validateLast(last) {
    invariant(last >= 1, 'PageSelector needs to render at least one page');
  }

  _onPreviousClicked() {
    if (this._isCurrentFirst()) return;
    this.props.onChange(this.props.current - 1);
  }

  _onNextClicked() {
    if (this._isCurrentLast()) return;
    this.props.onChange(this.props.current + 1);
  }

  _onButtonClicked(event) {
    this.props.onChange(event.currentTarget.dataset.pageNumber);
  }

  _isCurrentFirst() {
    return this.props.current <= 1;
  }

  _isCurrentLast() {
    return this.props.current === this.props.last;
  }

  _renderButtons() {
    if (this.props.last <= RENDER_ALL_BUTTONS_LIMIT) {
      return this._renderAllButtons();
    }

    return this._renderSomeButtons();
  }

  _renderAllButtons() {
    return new Array(this.props.last)
      .fill(null)
      .map((item, index) => this._renderButton(index + 1));
  }

  _renderSomeButtons() {
    const { last, current } = this.props;
    return [
      this._renderButton(1),
      current !== 2 && this._renderSeparator(),
      current > 1 && current < last && this._renderButton(current),
      current > 1 && current < last - 1 && this._renderSeparator(),
      this._renderButton(this.props.last),
    ];
  }

  _renderButton(pageNumber) {
    const isCurrent = pageNumber === this.props.current;
    const classes = classnames(
      styles.PageSelector_button,
      testClass('button'),
      testClass(pageNumber),
      { [styles.__active]: isCurrent },
    );
    return (
      <button
        className={classes}
        key={pageNumber}
        onClick={isCurrent ? undefined : this._onButtonClicked}
        data-page-number={pageNumber}
      >
        {pageNumber}
      </button>
    );
  }

  _renderSeparator() {
    return (
      <div
        className={classnames(
          styles.PageSelector_separator,
          testClass('separator'),
        )}
      >
        …
      </div>
    );
  }

  render() {
    return (
      <div className={styles.PageSelector}>
        <a
          className={classnames(
            styles.PageSelector_arrow,
            testClass('previous'),
          )}
          onClick={this._onPreviousClicked}
          disabled={this._isCurrentFirst()}
        >
          <Icon id="chevron-small-left" />
        </a>
        <div className={styles.PageSelector_buttons}>
          {this._renderButtons()}
        </div>
        <a
          className={classnames(styles.PageSelector_arrow, testClass('next'))}
          onClick={this._onNextClicked}
          disabled={this._isCurrentLast()}
        >
          <Icon id="chevron-small-right" />
        </a>
      </div>
    );
  }
}

PageSelector.propTypes = {
  last: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PageSelector;



// WEBPACK FOOTER //
// ./components/PageSelector/index.jsx